// import { useRouter } from 'next/navigation'

import { useEffect, useState } from "react";

import Header from "../../components/header/index";
import LoginGoogle from "../../components/payment/button-login/LoginGoogle";
import { LocalStorageService } from "../../helpers";
import { ToastContainer } from "react-toastify";
import { useTranslation } from "react-i18next";
import Search from "../../components/payment/search";
import useConfigEnv from "../../zustand";

const Payment = ({ school, logo }: { school: string; logo: string }) => {
  const accessTokenExp = LocalStorageService.getAccessToken();
  const { t } = useTranslation();
  const [inputValue, setInputValue] = useState("");
  const [captchaToken, setCaptchaToken] = useState("");
  const { env }: any = useConfigEnv()

  return (
    <>
      <Header logo={logo} center={true} />
      <div className="mx-auto flex h-fit w-full items-center justify-center ">
        <div className="flex h-fit w-full items-center justify-center bg-[url('../public/images/payment/bg.svg')] bg-fixed bg-center bg-no-repeat p-4 pb-[200px] md:pt-[60px]">
          <div className="flex flex-col items-center gap-[16px]">
            <div className="mt-6 text-[64px] font-semibold leading-normal tracking-[0.64px]">
              <span className="text-[38px] text-primary md:text-[64px]">
                {t("lookup")}{" "}
              </span>
              <span className="text-[38px] text-black md:text-[64px]">
                {t("payment")}
              </span>
            </div>
            {env?.paymentResearch === "true" && (
              <div className="mt-[18px] flex items-start justify-center gap-4">
                <Search
                  school={school}
                  inputValue={inputValue}
                  setInputValue={setInputValue}
                  captchaToken={captchaToken}
                  setCaptchaToken={setCaptchaToken}
                />
              </div>
            )}
            {env?.loginGG === "true" && <LoginGoogle />}
          </div>
        </div>
        <ToastContainer />
      </div>
    </>
  );
};

export default Payment;
